// 封装一个 axios 文件
import axios from "axios";
import baseURL from '@/api/baseURL.js'
import request from "@/utils/request.js";
import request2 from "@/utils/request2.js"
let headers = {
    'Content-Type': 'application/json; charset=UTF-8'
}
const token = localStorage.token;
if(token) headers.token = token

function post(url, data) {
    return request({
        url,
        method: "POST",
        data,
        headers
    });
}

function get(url, data) {
    return request({
        url,
        method: "GET",
        params: data
    });
}
const requresUrl = baseURL
//救助管理列表
export const helpManageFamilyEnvList = (params) => {
  return request({
      url: "/admin/rescueOrg/info/listRescueOrg",
      method: "POST",
      data: params
  });
}

//救助管理删除
export const helpManageFamilyEnvDelete = (params) => {
  return request({
      url: "/admin/rescueOrg/info/deleteRescueOrg",
      method: "POST",
      data: params
  });
}

//新增或者修改救助管理
export const helpManageFamilyEnvEdit = (params) => {
  return request({
      url: "/admin/rescueOrg/info/insertOrUpdate",
      method: "POST",
      data: params
  });
}

//救助管理获取数据
export const helpManageFamilyEnvCheck = (params) => {
  return request({
      url: "/admin/rescueOrg/info/getRescueOrg",
      method: "POST",
      data: params
  });
}


//救助政策
//救助政策获取列表
export const helpManagePolicyList = (params) => {
  return request({
      url: "/admin/rescuePolicy/info/listRescuePolicy",
      method: "POST",
      data: params
  });
}

//救助政策删除
export const helpManagePolicyDelete = (params) => {
  return request({
      url: "/admin/rescuePolicy/info/deleteRescuePolicy",
      method: "POST",
      data: params
  });
}

//新增或者修改救助政策
export const helpManagePolicyEdit = (params) => {
  return request({
      url: "/admin/rescuePolicy/info/insertOrUpdate",
      method: "POST",
      data: params
  });
}

//救助政策获取数据回写
export const helpManagePolicyCheck = (params) => {
  return request({
      url: "/admin/rescuePolicy/info/getRescuePolicy",
      method: "POST",
      data: params
  });
}

//救助政策分类
//救助政策分类获取列表
export const helpManagePolicyTypeList = (params) => {
  return request({
      url: "/admin/rescuePolicyType/info/listRescuePolicyType",
      method: "POST",
      data: params
  });
}

//救助政策分类删除
export const helpManagePolicyTypeDelete = (params) => {
  return request({
      url: "/admin/rescuePolicyType/info/deleteRescuePolicyType",
      method: "POST",
      data: params
  });
}

//新增或者修改救助政策分类
export const helpManagePolicyTypeEdit = (params) => {
  return request({
      url: "/admin/rescuePolicyType/info/insertOrUpdate",
      method: "POST",
      data: params
  });
}

//救助政策分类获取数据回写
export const helpManagePolicyTypeCheck = (params) => {
  return request({
      url: "/admin/rescuePolicyType/info/getRescuePolicyType",
      method: "POST",
      data: params
  });
}


//救助类型接口
//救助类型接口列表
export const helpManageHelpTypeList = (params) => {
  return request({
      url: "/admin/rescueType/info/listRescueType",
      method: "POST",
      data: params
  });
}

//救助类型接口删除
export const helpManageHelpTypeDelete = (params) => {
  return request({
      url: "/admin/rescueType/info/deleteRescueType",
      method: "POST",
      data: params
  });
}

//新增或者修改救助类型接口
export const helpManageHelpTypeEdit = (params) => {
  return request({
      url: "/admin/rescueType/info/insertOrUpdate",
      method: "POST",
      data: params
  });
}

//救助类型接口获取数据回写
export const helpManageHelpTypeCheck = (params) => {
  return request({
      url: "/admin/rescueType/info/getRescueType",
      method: "POST",
      data: params
  });
}


//救助档案
//救助档案列表
export const helpManageRecordList = (params) => {
  return request({
      url: "/admin/rescueArchives/info/listRescueArchives",
      method: "POST",
      data: params
  });
}

//救助档案删除
export const helpManageRecordDelete = (params) => {
  return request({
      url: "/admin/rescueArchives/info/deleteRescueArchives",
      method: "POST",
      data: params
  });
}

//新增或者修改救助档案
export const helpManageRecordEdit = (params) => {
  return request({
      url: "/admin/rescueArchives/info/insertOrUpdate",
      method: "POST",
      data: params
  });
}

//救助档案获取数据回写
export const helpManageRecordCheck = (params) => {
  return request({
      url: "/admin/rescueArchives/info/getRescueArchives",
      method: "POST",
      data: params
  });
}

//家庭成员
//家庭成员列表
export const helpManageFamilyList = (params) => {
  return request({
      url: "/admin/rescueFamilyPerson/info/listRescueFamilyPerson",
      method: "POST",
      data: params
  });
}

//家庭成员删除
export const helpManageFamilyDelete = (params) => {
  return request({
      url: "/admin/rescueFamilyPerson/info/deleteRescueFamilyPerson",
      method: "POST",
      data: params
  });
}

//新增或者修改家庭成员
export const helpManageFamilyEdit = (params) => {
  return request({
      url: "/admin/rescueFamilyPerson/info/insertOrUpdate",
      method: "POST",
      data: params
  });
}

//家庭成员获取数据回写
export const helpManageFamilyCheck = (params) => {
  return request({
      url: "/admin/rescueFamilyPerson/info/getRescueFamilyPerson",
      method: "POST",
      data: params
  });
}



//家庭成员附件
//家庭成员附件列表
export const helpManageFamilyImgList = (params) => {
  return request({
      url: "/admin/rescueEnclosure/info/listRescueEnclosure",
      method: "POST",
      data: params
  });
}

//家庭成员附件删除
export const helpManageFamilyImgDelete = (params) => {
  return request({
      url: "/admin/rescueEnclosure/info/deleteRescueEnclosure",
      method: "POST",
      data: params
  });
}

//新增或者修改家庭成员附件
export const helpManageFamilyImgEdit = (params) => {
  return request({
      url: "/admin/rescueEnclosure/info/insertOrUpdate",
      method: "POST",
      data: params
  });
}

//家庭成员附件获取数据回写
export const helpManageFamilyImgCheck = (params) => {
  return request({
      url: "/admin/rescueEnclosure/info/getRescueEnclosure",
      method: "POST",
      data: params
  });
}

//家庭成员救助记录
//家庭成员救助记录列表
export const helpManageFamilyLogList = (params) => {
  return request({
      url: "/admin/rescueRecord/info/listRescueRecord",
      method: "POST",
      data: params
  });
}

//家庭成员救助记录删除
export const helpManageFamilyLogDelete = (params) => {
  return request({
      url: "/admin/rescueRecord/info/deleteRescueRecord",
      method: "POST",
      data: params
  });
}

//新增或者修改家庭成员救助记录
export const helpManageFamilyLogEdit = (params) => {
  return request({
      url: "/admin/rescueRecord/info/insertOrUpdate",
      method: "POST",
      data: params
  });
}

//家庭成员救助记录获取数据回写
export const helpManageFamilyLogCheck = (params) => {
  return request({
      url: "/admin/rescueRecord/info/getRescueRecord",
      method: "POST",
      data: params
  });
}





//新增
//新增 基础库中的信息
export const helpList = (params) => {
  return request({
      url: "/admin/rescueArchives/info/listRescuePerson",
      method: "POST",
      data: params
  });
}

//新增
//POST /设为救助档案
export const helpListRescuePerson = (params) => {
  return request({
      url: "admin/rescueArchives/info/updateRescuePerson",
      method: "POST",
      data: params
  });
}

//导出
export const helpListOut = (params) => {
  return request2({
      url: "/admin/rescueRecord/info/downloadVeteransExcel",
      method: "POST",
      data: params,
      responseType: 'blob'
  });
}


//救助公示接口
//救助公示接口列表
export const helpManagePublicityList = (params) => {
  return request({
      url: "/admin/rescuePublicity/info/listRescuePublicity",
      method: "POST",
      data: params
  });
}

//救助公示接口删除
export const helpManagePublicityDelete = (params) => {
  return request({
      url: "/admin/rescuePublicity/info/deleteRescuePublicity",
      method: "POST",
      data: params
  });
}

//新增或者修改救助公示接口
export const helpManagePublicityEdit = (params) => {
  return request({
      url: "/admin/rescuePublicity/info/insertOrUpdate",
      method: "POST",
      data: params
  });
}

//救助公示接口回写
export const helpManagePublicityCheck = (params) => {
  return request({
      url: "/admin/rescuePublicity/info/getRescuePublicity",
      method: "POST",
      data: params
  });
}
//拿到树
export const getTreeData = (params) => {
  return request({
      url: "/rbac/admin/org/info/OrgTreelist",
      method: "POST",
      data: params
  });
}  
//救助公示档案人员
export const getRecordData = (params) => {
  return request({
      url: "/admin/rescuePublicity/info/findRescueArchivesPublicity",
      method: "POST",
      data: params
  });
} 

//新增督办事件
function insertProofOfEstablishment(data) {
    return post("/admin/event/info/insertProofOfEstablishment", data)
}
//获取待办事件
function listProofOfEstablishment(data) {
    return post("/admin/event/info/listProofOfEstablishment", data)
}
//修改督办事件
function updateProofOfEstablishment(data) {
    return post("/admin/event/info/updateEvent", data)
}
//废除督办事件
function deleteProofOfEstablishment(data) {
    return post("/admin/event/info/deleteProofOfEstablishment", data)
}
//获取单个督办事件
function getProofOfEstablishment(data) {
    return post("/admin/event/info/getProofOfEstablishment", data)
}
//上传文件
function uplodfiles(data) {
    return post("/eventUpload/info/uplodfiles", data)
}
//审核
function examine(data) {
    return post("/admin/event/info/examine", data)
}
//查看党员投票关键字
function findPartyVoteKeywords(data) {
    return post("/admin/party/vote/info/findPartyReportKeywords", data)
}
//查看党员投票类型数量
function findPartyVoteNumbers() {
    return post("/admin/party/vote/info/partyVoteStatistics")
}
//查看近五年发布活动情况
function findPartyVoteYears(data) {
    return post("/admin/party/vote/info/findPartyVoteYears", {})
}
//获取权限
function getLoginUserInfo(data) {
    return post("/admin/user/info/getLoginUserInfo", data)
}
//登录
function userLogin(data) {
    return post("/admin/login", data)
}
//上传照片
function uploadPartyPhoto(data) {
    return post("/controller/uploadVotePic/info/uploadPartyPhoto", data)
}

// 社区服务意见
// 意见列表
function opinionList(data) {
    return post("/admin/opinionCollection/info/findOpinionPerson", data)
}
// 意见列表导出
function downloadOpinionPerson(data) {
    return post("/admin/opinionCollection/info/downloadOpinionPerson", data)
}
// 新增意见
function insertOpinionCollection(data) {
    return post("/admin/opinionCollection/info/insertOpinionCollection", data)
}
// 删除意见
function deleteOpinionPerson(data) {
    return post("/admin/opinionCollection/info/deleteOpinionPerson", data)
}
// 意见详情
function findOpinionPersonById(data) {
    return post("/admin/opinionCollection/info/findOpinionPersonById", data)
}
//意见处理
function disposeOpinionPerson(data) {
    return post("/admin/opinionCollection/info/disposeOpinionPerson", data)
}
// 社区服务 意见 end


// 社区服务 兑换商品
// 兑换列表
function findExchange(data) {
    return post("/admin/exchange/info/findExchange", data)
}
// 兑换列表详情
function findExchangeById(data) {
    return post("/admin/exchange/info/findExchangeById", data)
}
// 保存修改
function updateExchange(data) {
    return post("/admin/exchange/info/updateExchange", data)
}
// 社区服务 兑换商品 end

// 社区服务 商品列表
// 商品列表
function findGoods(data) {
    return post("/admin/goods/info/findGoods", data)
}
// 上传图片
function uploadGoodsPhoto(data) {
    let fd = new FormData()
    // fd.append("token", token)
    fd.append('file', data)
    return post("/admin/goods/info/uploadGoodsPhoto", fd)
}
// 列表详细信息
function findGoodsById(data) {
    return post("/admin/goods/info/findGoodsById", data)
}
// 修改保存
function updateGoods(data) {
    return post("/admin/goods/info/updateGoods", data)
}
// 新增商品
function insertGoods(data) {
    return post("/admin/goods/info/insertGoods", data)
}
// 删除商品
function deleteGoods(data) {
    return post("/admin/goods/info/deleteGoods", data)
}
// 导出
function downloadGoods(data) {
    return axios({
        url: "/admin/goods/info/downloadGoods",
        method: "POST",
        data,
        responseType: 'blob'
    });
}
// 社区服务 商品列表 end
// 列表

// 服务推送
function findServicePush(data) {
    return post("/admin/servicePush/info/findServicePush", data)
}
// 上传附件
function uploadServicePushFile(data) {
    let fd = new FormData()
    // fd.append("token", token)
    fd.append('file', data)
    return post("/admin/servicePush/info/uploadServicePushFile", fd)
}
// 新增服务
function insertServicePush(data) {
    return post("/admin/servicePush/info/insertServicePush", data)
}
// 查看列表详情
function findServicePushById(data) {
    return post("/admin/servicePush/info/findServicePushById", data)
}
// 修改
function updateServicePush(data) {
    return post("/admin/servicePush/info/updateServicePush", data)
}
// 删除
function deleteServicePush(data) {
    return post("/admin/servicePush/info/deleteServicePush", data)
}
// 服务推送 end
// 敏感字管理
// 列表
function findSensitive(data) {
    return post("/admin/sensitive/info/findSensitive", data)
}
// 新增
function insertSensitive(data) {
    return post("/admin/sensitive/info/insertSensitive", data)
}
// 删除
function deleteSensitive(data) {
    return post("/admin/sensitive/info/deleteSensitive", data)
}
// 批量删除
function batchDeleteSensitive(data) {
    return post("/admin/sensitive/info/batchDeleteSensitive", data)
}
// 启用或者禁用
function updateSensitive(data) {
    return post("/admin/sensitive/info/updateSensitive", data)
}
// 获取详情
function findSensitiveById(data) {
    return post("/admin/sensitive/info/findSensitiveById", data)
}
// 敏感字管理 end
// 投诉建议管理
// 列表
function findComplaints(data) {
    return post("/admin/complaints/info/findComplaints", data)
}
// 列表详情
function findComplaintsById(data) {
    return post("/admin/complaints/info/findComplaintsById", data)
}
// 处理
function dealComplaints(data) {
    return post("/admin/complaints/info/dealComplaints", data)
}
// 转批
function turnComplaints(data) {
    return post("/admin/complaints/info/turnComplaints", data)
}
// 删除
function deleteComplaints(data) {
    return post("/admin/complaints/info/deleteComplaints", data)
}
// 投诉建议管理 end
// 团队发展
// 列表
function findTeam(data) {
    return post("/admin/team/info/findTeam", data)
}
// 新增团队
function insertTeam(data) {
    return post("/admin/team/info/insertTeam", data)
}
// 删除
function deleteTeam(data) {
    return post("/admin/team/info/deleteTeam", data)
}
// 详细信息
function findTeamById(data) {
    return post("/admin/team/info/findTeamById", data)
}
// 审核
function auditTeam(data) {
    return post("/admin/team/info/auditTeam", data)
}
// 团队人员列表
function findTeamPerson(data) {
    return post("/admin/team/info/findTeamPerson", data)
}
// 删除人员列表
function deleteTeamPerson(data) {
    return post("/admin/team/info/deleteTeamPerson", data)
}
// 人员列表详情
function findTeamPersonById(data) {
    return post("/admin/team/info/findTeamPersonById", data)
}
// 人员审核
function auditTeamPerson(data) {
    return post("/admin/team/info/auditTeamPerson", data)
}
// 团队发展 end
// 政策管理
// 列表
function findPolicy(data) {
    return post("/admin/policy/info/findPolicy", data)
}
// 新增
function insertPolicy(data) {
    return post("/admin/policy/info/insertPolicy", data)
}
// 删除
function deletePolicy(data) {
    return post("/admin/policy/info/deletePolicy", data)
}
// 列表详情
function findPolicyById(data) {
    return post("/admin/policy/info/findPolicyById", data)
}
// 修改
function updatePolicy(data) {
    return post("/admin/policy/info/updatePolicy", data)
}
// 政策管理 end
// 积分管理
// 列表
function findPersonIntegral(data) {
    return post("/admin/personIntegral/info/findPersonIntegral", data)
}
// 积分管理 end

function getAllChildren(data) {
    return post("/admin/org/info/getAllChildren", data)
}
// 获取街道、社区、网格的人员
function getGridPerson(data) {
    return post("/admin/org/info/findOrgById", data)
}

function findSectionByGridCode(data) {
    return post("/admin/section/info/findSectionByGridCode", data)
}
//文体活动
//获取文体活动列表
function listRecreationalActivity(data) {
    return post("/admin/recreationalActivity/info/listRecreationalActivity", data)
}

//新增文体活动列表
function recreationalActivityInsert(data) {
    return post("/admin/recreationalActivity/info/insert", data)
}
//修改文体活动
function recreationalActivityUpdate(data) {
    return post("/admin/recreationalActivity/info/update", data)
}
//删除文体活动
function recreationalActivityDelete(data) {
    return post("/admin/recreationalActivity/info/delete", data)
}
//活动总结新增
function recreationalActivitySummaryInsert(data) {
    return post("/admin/recreationalActivitySummary/info/insert", data)
}
//活动总结修改
function recreationalActivitySummaryUpdate(data) {
    return post("/admin/recreationalActivitySummary/info/update", data)
}
//活动总结删除
function recreationalActivitySummaryDelete(data) {
    return post("/admin/recreationalActivitySummary/info/delete", data)
}

//活动人员修改
function recreationalActivityApplicantUpdate(data) {
    return post("/admin/recreationalActivityApplicant/info/update", data)
}

//批量审批活动人员
function recreationalActivityApplicantBatchAduit(data) {
    return post("/admin/recreationalActivityApplicant/info/batchAduit", data)
}

//查看报名人员情况
function findRegistrationDetailById(data) {
    return post("/admin/recreationalActivity/info/findRegistrationDetailById", data)
}

//修改活动总结评论
function recreationalActivitySummaryCommentUpdate(data) {
    return post("/admin/recreationalActivitySummaryComment/info/update", data)
}

//回复
function recreationalActivitySummaryCommentInsert(data) {
    return post("/admin/recreationalActivitySummaryComment/info/insert", data)
}
//考勤地图
function attendanceRecordStatisticsByMap(data) {
    return post("/admin/attendanceRecord/info/attendanceRecordStatisticsByMap", data)
}

export {
    get,
    recreationalActivitySummaryCommentUpdate,
    recreationalActivitySummaryCommentInsert,
    recreationalActivityApplicantUpdate,
    findRegistrationDetailById,
    recreationalActivitySummaryUpdate,
    recreationalActivitySummaryDelete,
    recreationalActivityApplicantBatchAduit,
    requresUrl,
    post,
    findSectionByGridCode,
    insertProofOfEstablishment,
    listProofOfEstablishment,
    updateProofOfEstablishment,
    deleteProofOfEstablishment,
    getProofOfEstablishment,
    uplodfiles,
    examine,
    findPartyVoteYears,
    findPartyVoteNumbers,
    findPartyVoteKeywords,
    getLoginUserInfo,
    userLogin,
    uploadPartyPhoto,
    opinionList,
    // 社区服务意见
    downloadOpinionPerson,
    insertOpinionCollection,
    deleteOpinionPerson,
    findOpinionPersonById,
    disposeOpinionPerson,
    // 社区服务意见 end
    // 社区服务 兑换商品
    findExchange,
    findExchangeById,
    updateExchange,
    // 社区服务 兑换商品 end
    // 社区服务 商品列表
    findGoods,
    uploadGoodsPhoto,
    findGoodsById,
    updateGoods,
    insertGoods,
    deleteGoods,
    downloadGoods,
    // 社区服务 商品列表 end
    // 服务推送
    findServicePush,
    uploadServicePushFile,
    insertServicePush,
    findServicePushById,
    updateServicePush,
    deleteServicePush,
    // 服务推送 end
    // 敏感字管理
    findSensitive,
    insertSensitive,
    deleteSensitive,
    batchDeleteSensitive,
    updateSensitive,
    findSensitiveById,
    // 敏感字管理 end
    // 投诉建议管理
    findComplaints,
    findComplaintsById,
    dealComplaints,
    turnComplaints,
    deleteComplaints,
    // 投诉建议管理 end
    // 团队发展
    findTeam,
    insertTeam,
    deleteTeam,
    findTeamById,
    auditTeam,
    findTeamPerson,
    deleteTeamPerson,
    findTeamPersonById,
    auditTeamPerson,
    // 团队发展 end
    // 政策管理
    findPolicy,
    insertPolicy,
    deletePolicy,
    findPolicyById,
    updatePolicy,
    // 政策管理 end
    // 积分管理
    findPersonIntegral,
    // 积分管理 end,
    getAllChildren,
    listRecreationalActivity,
    recreationalActivityInsert,
    recreationalActivityUpdate,
    recreationalActivityDelete,
    recreationalActivitySummaryInsert,
    //获取街道、社区、网格人员
    getGridPerson,
    //考勤地图
    attendanceRecordStatisticsByMap
}